import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { PesquisaFornecedorRequest, Types } from './types';

// ACTIONS
import {
	pesquisaFornecedorSuccess,
	pesquisaFornecedorFailure,
} from './actions';

function* pesquisaFornecedorRequest(request: ReducerAction) {
	const { payload }: { payload: PesquisaFornecedorRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`fornecedores/${CHANNEL}/fornecedores`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(pesquisaFornecedorSuccess(response));
	} else {
		yield put(pesquisaFornecedorFailure(response));
	}
}

export default all([
	takeLatest(Types.PESQUISA_FORNECEDOR_REQUEST, pesquisaFornecedorRequest),
]);
